export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40dc0b49b16c09130e542cbca89e1bb3fa1c779b9b&name=revalidateCommunity!'